export default __webpack_public_path__ + "static/media/globe.f3491b53.svg";